import React from 'react';
import { theme } from '@sg/garnish';

import { useLaunchDarkly } from '@order/LaunchDarkly';

import { AppContent } from './App.content';
import {
  ErrorFallback,
  ForceUpdateMode,
  LoadingAnimation,
  MaintenanceMode,
  useIsForceUpdateModeEnabled,
  useIsMaintenanceModeEnabled,
} from './components';
import {
  use3rdPartyIntegrations,
  useAppFonts,
  useSession,
  useStartOtaObserver,
} from './hooks';

// ────────────────────────────────────────────────────────────────────────────────

/**
 * Conditionally renders the app by detecting possible blocks
 * (app fonts loading, "Force Update" mode, "Maintenance" mode, and so on).
 */
export const App = () => {
  const appFontsLoaded = useAppFonts();
  const { sessionReady, sessionError } = useSession();
  const { isReady: isLaunchDarklyReady } = useLaunchDarkly();
  const isMaintenanceModeEnabled = useIsMaintenanceModeEnabled();
  const isForceUpdatedModeEnabled = useIsForceUpdateModeEnabled();

  use3rdPartyIntegrations();
  useStartOtaObserver();

  // ─────────────────────────────────────────────────────────────────────

  const isLoading = !appFontsLoaded || !sessionReady || !isLaunchDarklyReady;

  if (sessionError) return <ErrorFallback error={sessionError} />;

  if (isLoading) {
    return (
      <LoadingAnimation
        withNavbarOffset
        backgroundColor={theme.colors.APP_BACKGROUND}
      />
    );
  }

  if (isForceUpdatedModeEnabled) return <ForceUpdateMode />;

  if (isMaintenanceModeEnabled) return <MaintenanceMode />;

  return <AppContent />;
};
